export default "__VITE_ASSET__BLO8TJfJ__"